const MetaTraderWebTerminalContentFour = () => {
  return (
    <div className="how__work__platform">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="thumb-left">
              <div className="content-left">
                <h2>Access the World’s Most Popular Markets</h2>

                <p>
                  Trade across a wide range of instruments, all from one
                  browser-based platform.
                </p>
              </div>
              <img
                src={process.env.PUBLIC_URL + "/images/platforms/meta_trader_web_terminal/meta_trader_web_terminal_03.png"}
                alt="computer images"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <h3>Forex</h3>
              <p>
                Trade major, minor, and exotic currency pairs with tight spreads
                and fast execution speeds, all from your browser without
                installing any software.
                {/* Conversely, rate cuts can weaken a
                currency as investors seek higher yields elsewhere. Traders
                closely follow central bank announcements and policy statements
                to anticipate shifts in monetary policy. */}
              </p>
              <hr className="black-line" />
              <h3> Stocks</h3>
              <p>
                Gain exposure to global companies with flexible leverage
                options. Monitor price action in real time and trade stocks
                directly via the Web Terminal.
                {/* Stable inflation and strong
                performance usually strengthen a currency, while economic
                slowdown or uncertainty can cause depreciation. Traders monitor
                key indicators like CPI, PMI, and retail sales to identify
                potential trends in currency valuation. */}
              </p>
              <hr className="black-line" />
              <h3>Commodities</h3>
              <p>
                Diversify your portfolio with energy, metal, and agricultural
                products. Execute trades easily, backed by live market updates
                and chart analysis tools.
                {/* In contrast, geopolitical
                tensions or unexpected global events can increase volatility as
                traders move toward safe-haven assets like the USD, CHF, or JPY. */}
              </p>
              <hr className="black-line" />
              <h3>Indices</h3>
              <p>
                Trade leading global indices and capture broad market movements
                with accurate, real-time data.
                {/* Large institutional players and algorithmic trading
                systems can amplify these effects, making sentiment analysis a
                valuable tool for modern forex traders. */}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaTraderWebTerminalContentFour;
